import { useState } from "react";

/* ============================================================
   PAST PRESIDENTS PAGE  (Option A: img with SVG fallback)
   ------------------------------------------------------------
   HOW TO ADD A REAL PHOTO:
   Just put the photo URL (or /images/xyz.jpg from public folder)
   in the "img" field of any member below. Example:
     { name: "Sanjay Nayar", company: "...", term: "2024-2025",
       img: "/images/presidents/sanjay-nayar.jpg" }
   If img is empty ("") OR the image fails to load,
   the SVG portrait silhouette is shown automatically.
   ============================================================ */

/* ---------------- DATA ---------------- */
const pastPresidents = [
  { name: "Sanjay Nayar", company: "Sorin Investment Fund", term: "2024-2025", img:  "https://assocham.org/assocham_backend/assets/images/pp/sanjay.jpg", },
  { name: "Ajay Singh", company: "Spicejet", term: "2023-2024", img: "https://assocham.org/assocham_backend/assets/images/pp/ajay.jpg" },
  { name: "Sumant Sinha", company: "Renew Power", term: "2022-2023", img: "https://assocham.org/assocham_backend/assets/images/pp/SumantSinha.jpg" },
  { name: "Vineet Agarwal", company: "Transport Corporation of India Limited", term: "2020-2022", img: "https://assocham.org/assocham_backend/assets/images/pp/image.jpg" },
  { name: "Dr. Niranjan Hiranandani", company: "Hiranandani Group of Companises", term: "2019-2020", img: "https://assocham.org/assocham_backend/assets/images/pp/niranjan-past-president.jpg" },
  { name: "Balkrishan Goenka", company: "Welspun Enterprises", term: "2018-2019", img: "https://assocham.org/assocham_backend/assets/images/pp/bkg-pic.jpg" },
  { name: "Sandeep Jajodia", company: "Monnet International", term: "2017-2018", img: "https://assocham.org/assocham_backend/assets/images/pp/SandeepJajodia.jpg" },
  { name: "Sunil Kanoria", company: "Vara Technology", term: "2015-2017", img: "https://assocham.org/assocham_backend/assets/images/pp/sunilk.jpg" },
  { name: "Dr. Rana Kapoor", company: "Yes Bank Limited", term: "2013-2015", img: "https://assocham.org/assocham_backend/assets/images/pp/rana-past-president.jpg" },
  { name: "Rajkumar Dhoot", company: "Videocon", term: "2012-2013", img: "https://assocham.org/assocham_backend/assets/images/pp/rajkumar-past-president.jpg" },
  { name: "Dilip Modi", company: "S Mobility Limited", term: "2010-2012", img: "https://assocham.org/assocham_backend/assets/images/pp/DilipModi.jpg" },
  { name: "Dr. Swati Piramal", company: "Piramal Finance Limited", term: "2009-2010", img: "https://assocham.org/assocham_backend/assets/images/pp/SwatiPiramal.jpg" },
  { name: "Sajjan Jindal", company: "JSW Steel Limited", term: "2008-2009", img: "https://assocham.org/assocham_backend/assets/images/pp/SajjanJindal.jpg" },
  { name: "Venugopal N. Dhoot", company: "Videocon Industries", term: "2007-2008", img: "https://assocham.org/assocham_backend/assets/images/pp/venugopal.jpg" },
  { name: "Anil Agarwal", company: "Cosmos International", term: "2005-2007", img: "https://assocham.org/assocham_backend/assets/images/pp/AnilAgarwal.jpg" },
  { name: "Mahendra K.Sanghi", company: "Sanghi Udyog India Pvt. Ltd.", term: "2003-2005", img: "https://assocham.org/assocham_backend/assets/images/pp/MahendraSanghi.jpg" },
  { name: "R. K. Somany", company: "HSIL Limited", term: "2002-2003", img: "https://assocham.org/assocham_backend/assets/images/pp/RKSomany.jpg" },
  { name: "K. K. Nohria", company: "Crompton Greaves Ltd.", term: "2001-2002", img: "https://assocham.org/assocham_backend/assets/images/pp/KKNohria.jpg" },
  { name: "Raghu Mody", company: "The Rasoi Group", term: "2000-2001", img: "https://assocham.org/assocham_backend/assets/images/pp/RaghuMody.jpg" },
  { name: "Shekhar Bajaj", company: "Bajaj Electricals Ltd.", term: "1999-2000", img: "https://assocham.org/assocham_backend/assets/images/pp/ShekharBajaj.jpg" },
  { name: "K. P. Singh", company: "DLF Limited", term: "1998-1999", img: "https://assocham.org/assocham_backend/assets/images/pp/KPSingh.jpg" },
  { name: "L. Lakshman", company: "Rane Holdings Limited", term: "1997-1998", img: "https://assocham.org/assocham_backend/assets/images/pp/LLakshman.jpg" },
  { name: "H. L. Somany", company: "Somany Ceramics Limited", term: "1996-1997", img: "https://assocham.org/assocham_backend/assets/images/pp/HLSomany.jpg" },
  { name: "S. M. Datta", company: "Philips Electronics India Ltd.", term: "1995-1996", img: "https://assocham.org/assocham_backend/assets/images/pp/SMDatta.jpg" },
  { name: "Pranlal Bhogilal", company: "Vintage Cars Club of India", term: "1994-1995", img: "" },
  { name: "Hari Govind Singhania", company: "JK Technosoft/Jaykay Enterprises Ltd/JK Cotton Ltd", term: "1993-1994", img: "https://assocham.org/assocham_backend/assets/images/pp/GovindSinghania.jpg" },
  { name: "Dr. N. M. Dhuldhoya", company: "National Organic Chemical Industries Limited / Lalit Doshi Memorial Foundation", term: "1992-1993", img: "https://assocham.org/assocham_backend/assets/images/pp/DrNMDhuldhoya.jpg" },
  { name: "Late N. Sankar", company: "The Sanmar Group", term: "1991-1992", img: "https://assocham.org/assocham_backend/assets/images/pp/NSankar.jpg" },
  { name: "A. Mazumdar", company: "TIL India Limited/Gainwell", term: "1990-1991", img: "https://assocham.org/assocham_backend/assets/images/pp/AMazumdar.jpg" },
  { name: "Viren J. Shah", company: "Mukand Limited", term: "1989-1990", img: "https://assocham.org/assocham_backend/assets/images/pp/VirenJShah.jpg" },
  { name: "L. M. Thapar", company: "Thapar Group/The Avantha Group", term: "1988-1989", img: "" },
  { name: "M. K. Kumar", company: "", term: "1987-1988", img: "" },
  { name: "B. R. Sule", company: "", term: "1986-1986", img: "https://assocham.org/assocham_backend/assets/images/pp/BRSule.jpg" },
  { name: "S. P. Acharya", company: "United Spirits Limited", term: "1985-1986", img: "" },
  { name: "M. S. Patwardhan", company: "", term: "1984-1985", img: "https://assocham.org/assocham_backend/assets/images/pp/MSPatwardhan.jpg" },
  { name: "A. Srivasailam", company: "Tractors and Farm Equipment Limited", term: "1981-1982", img: "https://assocham.org/assocham_backend/assets/images/pp/ASrivasailam.jpg" },
  { name: "M. H. Mody", company: "Crown Holdings Private Limited", term: "1980-1981", img: "https://assocham.org/assocham_backend/assets/images/pp/MHMody.jpg" },
  { name: "A. L. Mudaliar", company: "Nikad India Business Solutions Pvt. Ltd.", term: "1979-1980", img: "https://assocham.org/assocham_backend/assets/images/pp/ALMudaliar.jpg" },
  { name: "H. P. Nanda", company: "Escorts Group", term: "1976-1977", img: "https://assocham.org/assocham_backend/assets/images/pp/HPNanda.jpg" },
  { name: "Akbar Hydari", company: "", term: "1975-1976", img: "https://assocham.org/assocham_backend/assets/images/pp/AkbarHydari.jpg" },
  { name: "A. N. Haksar", company: "Sr. Advocate (Retired)", term: "1973-1974", img: "https://assocham.org/assocham_backend/assets/images/pp/ANHaksar.jpg" },
  { name: "Bhaskar Mitter", company: "Andrew Yule & Co. Ltd.", term: "1972-1973", img: "" },
  { name: "Keshub Mahindra", company: "Mahindra & Mahindra Limited", term: "1971-1972", img: "https://assocham.org/assocham_backend/assets/images/pp/KeshubMahindra.jpg" },
].map((m, i) => ({ ...m, id: `pp-${i}` }));


/* ---------------- SVG FALLBACK PORTRAIT ---------------- */
function SilhouettePortrait() {
  return (
    <div
      className="relative flex h-full w-full items-end justify-center overflow-hidden rounded-full"
      style={{ background: "linear-gradient(160deg, #F3ECE2 0%, #EFE0CB 55%, #E8D2B4 100%)" }}
    >
      <svg viewBox="0 0 100 100" className="h-[92%] w-[92%] translate-y-[8%]" aria-hidden="true">
        <defs>
          <linearGradient id="ppGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#DA2128" />
            <stop offset="100%" stopColor="#EE8202" />
          </linearGradient>
        </defs>
        {/* head */}
        <circle cx="50" cy="36" r="18" fill="url(#ppGrad)" />
        {/* shoulders / suit */}
        <path d="M50 56c-19 0-31 12-33 30v14h66V86c-2-18-14-30-33-30z" fill="url(#ppGrad)" />
        {/* collar */}
        <path d="M42 58l8 10 8-10c-2.5-1.4-5.2-2-8-2s-5.5.6-8 2z" fill="#FFFFFF" opacity="0.9" />
        {/* tie */}
        <path d="M50 68l-3.4 6 3.4 18 3.4-18z" fill="#B8181E" />
      </svg>
    </div>
  );
}

/* ---------------- AVATAR (Option A: img OR svg fallback) ---------------- */
function Avatar({ member }) {
  const [imgError, setImgError] = useState(false);
  const hasImage = member.img && member.img.trim() !== "" && !imgError;

  return (
    <div className="avatar-ring relative h-32 w-32 rounded-full p-[3px] sm:h-36 sm:w-36">
      <div className="flex h-full w-full items-center justify-center rounded-full bg-white p-[5px]">
        {hasImage ? (
          /* ---- real photo ---- */
          <img
            src={member.img}
            alt={member.name}
            loading="lazy"
            onError={() => setImgError(true)}
            className="h-full w-full rounded-full object-cover object-top"
          />
        ) : (
          /* ---- svg fallback portrait ---- */
          <SilhouettePortrait />
        )}
      </div>
    </div>
  );
}

/* ---------------- CARD ---------------- */
function PresidentCard({ member, index }) {
  return (
    <div
      className="member-card group relative flex flex-col items-center rounded-2xl bg-white px-5 pb-8 pt-9 text-center shadow-[0_4px_20px_rgba(0,0,0,0.06)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_18px_40px_rgba(218,33,40,0.18)]"
      style={{ animationDelay: `${(index % 12) * 60}ms` }}
    >
    

      {/* avatar with hover zoom */}
      <div className="transition-transform duration-500 group-hover:scale-105">
        <Avatar member={member} />
      </div>

      <h3 className="mt-5 text-base font-bold text-gray-800 transition-colors duration-300 group-hover:text-[#DA2128]">
        {member.name}
      </h3>
      <p className="mt-1.5 min-h-[40px] text-sm leading-snug text-gray-500">
        {member.company || "\u00A0"}
      </p>

      {/* term badge - fills with gradient on hover */}
      <span className="mt-3 inline-flex items-center gap-2 rounded-full bg-[#F3ECE2] px-4 py-1.5 text-sm font-bold text-[#EE8202] transition-all duration-300 group-hover:bg-gradient-to-r group-hover:from-[#DA2128] group-hover:to-[#EE8202] group-hover:text-white">
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <path d="M16 2v4M8 2v4M3 10h18" />
        </svg>
        {member.term}
      </span>
    </div>
  );
}

/* ---------------- SECTION HEADING ---------------- */
function SectionHeading({ label, count }) {
  return (
    <div className="mb-10 flex items-center gap-4">
      <span className="h-10 w-1.5 rounded-full bg-gradient-to-b from-[#DA2128] to-[#EE8202]" />
      <div>
        <h2 className="text-2xl font-extrabold uppercase tracking-wide text-gray-800 sm:text-3xl">
          {label}
        </h2>
        {/* <p className="mt-0.5 text-sm font-medium text-[#EE8202]">{count} Distinguished Leaders</p> */}
      </div>
      <span className="ml-2 hidden h-px flex-1 bg-gradient-to-r from-[#EE8202]/40 to-transparent sm:block" />
    </div>
  );
}


/* ---------------- BREADCRUMB ---------------- */
function Breadcrumb() {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-white/25 bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-wide text-white shadow-lg backdrop-blur-md sm:text-sm">
        <li>
          <a href="#" className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#F3ECE2]">
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-white/60">&rsaquo;</li>
        <li>
          <a href="#" className="transition-colors duration-300 hover:text-[#F3ECE2]">About</a>
        </li>
        <li className="text-white/60">&rsaquo;</li>
        <li className="rounded-full bg-white px-3 py-1 text-[#DA2128] shadow-sm">Past Presedent</li>
      </ol>
    </nav>
  );
}

/* ---------------- PAGE ---------------- */
export default function PastPresedent() {
  return (
    <div className="min-h-screen bg-[#F3ECE2]">
      {/* ---------- HERO ---------- */}
       <header className="relative overflow-hidden bg-gradient-to-r from-[#DA2128] via-[#E04A1A] to-[#EE8202] py-16 text-center text-white sm:py-20">
        <Breadcrumb />
        {/* floating decorative circles */}
        <span className="floating absolute -left-10 top-8 h-40 w-40 rounded-full bg-white/10" />
        <span className="floating-slow absolute -right-8 bottom-0 h-52 w-52 rounded-full bg-white/10" />
        <span className="floating absolute left-1/3 top-2 h-14 w-14 rounded-full bg-white/10" />
        <div className="hero-in relative mx-auto max-w-3xl px-4">
          <p className="text-xs font-bold uppercase tracking-[0.35em] text-white/80">
            Honouring our legacy of leadership &middot; 1971 to today
          </p>
          <h1 className="mt-3 text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
            Past Presidents
          </h1>
          <div className="mx-auto mt-5 h-1 w-24 rounded-full bg-white/70" />
          <p className="mx-auto mt-5 max-w-xl text-sm text-white/85 sm:text-base">
            Visionary leaders who steered the Chamber over five decades, shaping
            policy, industry and enterprise across the nation.
          </p>
        </div>
      </header>

      {/* ---------- GRID ---------- */}
      <main className="mx-auto max-w-6xl px-4 py-12 sm:py-16">
        <SectionHeading label="Past Presidents" count={pastPresidents.length} />
        <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {pastPresidents.map((m, i) => (
            <PresidentCard key={m.id} member={m} index={i} />
          ))}
        </div>
      </main>

    </div>
  );
}
